import React, { useRef, useState, useEffect } from "react";
import Icon from "../Icon";
import CaseStudy1 from "../../assets/case-study-1.jpg";
import CaseStudy2 from "../../assets/case-study-2.png";
import CaseStudy3 from "../../assets/case-study-3.png";
import CaseStudy4 from "../../assets/case-study-4.png";
import CaseStudy5 from "../../assets/case-study-5.png";
import { Link } from "react-router-dom";

const caseStudies = [
  {
    id: "dipshit",
    label: "Wekelijkse samenwerkingen",
    title: "Dipshit: Van Dinsdagavond Naar Fenomeen",
    description:
      "Dipshit is hét voorbeeld van hoe strategie, momentum en community samen een wekelijkse clubavond legendarisch maken. Lees meer",
    image: CaseStudy1,
  },
  {
    id: "piv",
    label: "Strategische samenwerkingen",
    title: "PIV Festival: Extra Marketing Power",
    description:
      "PIV had hun marketing al strak staan. Maar door samen te werken met 22NIGHT kwam er een extra laag op: snelheid, urgentie en communityhype. Lees meer",
    image: CaseStudy2,
  },
  {
    id: "contra",
    label: "Spin en win samenwerkingen",
    title: "Contra w/ Bad Boombox: Strak Uitverkocht",
    description:
      "Contra stond voor een uitdaging: hun eerste editie met de grote naam Bad Boombox moest impact maken, maar de kaartverkoop bleef achter op de verwachtingen. Daar sprongen wij direct op in.",
    image: CaseStudy3,
  },
  {
    id: "binnenstad",
    label: "Wekelijkse samenwerkingen",
    title: "Binnenstad: De Perfecte Match",
    description:
      "Binnenstad snapt het spel. Ze weten precies hoe je onze community aanspreekt — en dat zie je terug in de cijfers. Inmiddels komt tot wel 40% van hun totale ticketverkoop via 22NIGHT.",
    image: CaseStudy4,
  },
  {
    id: "stelz",
    label: "Pilot samenwerkingen",
    title: "STËLZ Student Delivery Service: Van Testcase Naar Instant Succes",
    description:
      "STËLZ zocht een slimme manier om hun nieuwe Student Delivery Service in Amsterdam te lanceren, en koos onze community als de perfecte testcase.",
    image: CaseStudy5,
  },
];

export default function CaseStudiesSection({
  fromDetailPage = false,
  exclude = null,
}) {
  const scrollContainerRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const checkScrollButtons = () => {
    const container = scrollContainerRef.current;
    if (container) {
      setCanScrollLeft(container.scrollLeft > 0);
      const maxScroll = container.scrollWidth - container.clientWidth;
      setCanScrollRight(container.scrollLeft < maxScroll - 1);
    }
  };

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (container) {
      container.addEventListener("scroll", checkScrollButtons);
      checkScrollButtons();
    }
    return () => {
      if (container) {
        container.removeEventListener("scroll", checkScrollButtons);
      }
    };
  }, []);

  const scroll = (direction) => {
    const container = scrollContainerRef.current;
    if (container) {
      const scrollAmount = container.offsetWidth * 0.8;
      const newScrollPosition =
        container.scrollLeft +
        (direction === "right" ? scrollAmount : -scrollAmount);
      container.scrollTo({
        left: newScrollPosition,
        behavior: "smooth",
      });
    }
  };

  return (
    <div id="case-studies">
      <section
        className={`md:hidden flex flex-col gap-[16px] ${
          fromDetailPage ? "py-[48px]" : "mt-[48px]"
        }`}
      >
        <div className="font-semibold text-[22px] text-white leading-[26px]">
          Case studies die échte resultaten laten zien
        </div>
        {caseStudies
          .filter((card) => card.id !== exclude)
          .map((card) => (
            <Link
              to={`/partners/case-studies?id=${card.id}`}
              key={card.title}
            className="relative flex flex-col items-center gap-[12px] bg-[#0B0415CC] p-[24px_16px] border-[#292433] border-[1.5px] rounded-[18px] w-full h-[342px] text-center"
            style={{
              backgroundImage: `url(${card.image})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            <div className="absolute inset-0 bg-[#0B041590] rounded-[16px]"></div>
            <div className="z-10 flex flex-col justify-between items-start h-full">
              <div className="bg-[#E4D3FA] p-[6px_8px] rounded-[4px] font-semibold text-[#7721E5] text-[12px] uppercase leading-[16px]">
                {card.label}
              </div>
              <div className="flex flex-col gap-[12px] text-start">
                <div className="font-semibold text-[20px] text-white leading-[24px]">
                  {card.title}
                </div>
                <div className="font-normal text-[#F7F2FD] text-[16px] line-clamp-2 leading-[22px]">
                  {card.description}
                </div>
              </div>
            </div>
          </Link>
        ))}
      </section>
      <section
        className={`max-md:hidden flex flex-col gap-[16px] ${
          fromDetailPage ? "py-[72px]" : "mt-[96px]"
        }`}
      >
        <div className="flex justify-between max-md:items-center md:items-end pb-[14px]">
          <div className="font-semibold text-[36px] text-white leading-[36px] tracking-[-1px]">
            Case studies die échte <br />
            resultaten laten zien
          </div>

          <div className="flex items-center gap-5 lg:mr-7">
            <button
              onClick={() => scroll("left")}
              disabled={!canScrollLeft}
              className={`p-2 rounded-full shadow-lg transition-all duration-200 bg-white
                ${
                  canScrollLeft
                    ? "hover:bg-gray-50 lg:cursor-pointer opacity-100"
                    : "cursor-not-allowed opacity-40"
                }`}
              aria-label="Scroll left"
            >
              <Icon
                icon="heroicons:chevron-left"
                className="w-[20px] h-[20px] text-gray-800"
              />
            </button>
            <button
              onClick={() => scroll("right")}
              disabled={!canScrollRight}
              className={`p-2 rounded-full shadow-lg transition-all duration-200 bg-white
                ${
                  canScrollRight
                    ? "hover:bg-gray-50 lg:cursor-pointer opacity-100"
                    : "cursor-not-allowed opacity-40"
                }`}
              aria-label="Scroll right"
            >
              <Icon
                icon="heroicons:chevron-right"
                className="w-[20px] h-[20px] text-gray-800"
              />
            </button>
          </div>
        </div>

        <div
          ref={scrollContainerRef}
          className="flex gap-6 overflow-x-auto scroll-smooth hide-scrollbar"
          style={{
            scrollSnapType: "x mandatory",
            touchAction: "auto",
            overflowY: "visible",
          }}
        >
          {caseStudies.map((card) => (
            <Link
              to={`/partners/case-studies?id=${card.id}`}
              key={card.title}
              className="flex-none w-[calc(50%-8px)] scroll-snap-align-start"
              style={{
                scrollSnapAlign: "start",
                userSelect: "auto",
                pointerEvents: "auto",
                touchAction: "auto",
              }}
            >
              <div
                className="relative flex flex-col items-center gap-[12px] bg-[#0B0415CC] p-[24px_16px] border-[#292433] border-[1.5px] rounded-[18px] w-full h-[400px] text-center"
                style={{
                  backgroundImage: `url(${card.image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
              >
                <div className="absolute inset-0 bg-[#0B041590] rounded-[16px]"></div>
                <div className="z-10 flex flex-col justify-between items-start h-full">
                  <div className="bg-[#E4D3FA] p-[6px_8px] rounded-[4px] font-semibold text-[#7721E5] text-[14px] uppercase leading-[16px]">
                    {card.label}
                  </div>
                  <div className="flex flex-col gap-[12px] text-start">
                    <div className="font-semibold text-[26px] text-white leading-[32px]">
                      {card.title}
                    </div>
                    <div className="font-normal text-[#F7F2FD] text-[20px] line-clamp-2 leading-[26px]">
                      {card.description}
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <style>{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>
  );
}
